<template>
  <div
    class="printing-column-root"
    :style="styles"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styles() {
      if (this.fullWidth) {
        return 'flex-basis: 100%;';
      }

      return 'flex-basis: 30%;';
    },
  },
};
</script>

<style lang="scss" scoped>
.printing-column-root {
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
